import React from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import FormCondition from '../../../../Components/Form/FormCondition';
import DateField from '../../../../Components/Form/components/DateField';
import useApiClient from '../../../Base/Hooks/useApiClient';
import { useArchiveWorkplaceMemberMutation } from '../../../../graphql/graphql';
import ArchivationReasonSelectField from '../../../Base/Components/Inputs/ArchivationReasonSelect/ArchivationReasonSelectField';
import useTranslation from '../../../../Hooks/useTranslation';
import useFilters from '../../../Base/Hooks/useFilters';
import useNotification from '../../../../Hooks/useNotification.hook';
import { ArchivingReason } from '../../Enum/ArchivingReason.enum';

interface Props {
	patientId: string;
	workplaceId: string;
	onSuccess: () => void;
}

const ArchivePatient: React.FC<Props> = ({
	patientId,
	workplaceId,
	onSuccess,
}) => {
	const { t } = useTranslation();
	const { handleDateValue, handleSelectValue } = useFilters();
	const { showNotificationSuccess } = useNotification();
	const [archiveWorkplaceMember] = useArchiveWorkplaceMemberMutation();
	const { displayGQLError } = useApiClient();

	const validationSchema = yup.object({
		reason: yup.object().shape({
			value: yup.string().required(''),
		}),
		dateOfDeath: yup.mixed().when('reason.value', {
			is: ArchivingReason.DEATH,
			then: yup.date().required(t('validation.archivePatient.fillDateOfDeath')),
		}),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: any) => {
		const response = await archiveWorkplaceMember({
			input: {
				userId: patientId,
				workplaceId,
				reason: handleSelectValue(values?.reason?.item.id),
				dateOfDeath: handleDateValue(values?.dateOfDeath),
			},
		});
		displayGQLError(response);
		if (response?.data?.deleteWorkplaceMember.status) {
			showNotificationSuccess({
				content: t('component.archivePatient.patientHasBeenArchived'),
			});
			onSuccess();
		}
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<ArchivationReasonSelectField
					name='reason'
					label='component.archivePatient.reason'
					isRequired
				/>
			</InputWrapper>
			<FormCondition controlName='reason' equal='2'>
				<InputWrapper>
					<DateField
						name='dateOfDeath'
						label='component.archivePatient.dateOfDeath'
						isRequired
					/>
				</InputWrapper>
			</FormCondition>
			<div className='mt-3'>
				<SubmitButton
					onSubmit={handleSubmit}
					title='component.archivePatient.submitButton'
				/>
			</div>
		</FormWrapper>
	);
};

export default ArchivePatient;
